document.querySelector('[name="orderby"]')?.addEventListener('change', function () {
    const selectedValue = this.value;
    const url = new URL(window.location.href);

    url.searchParams.set('orderby', selectedValue);

    window.location.href = url.toString();
});